import { apiService } from "../../services/apiService";
import { utilService } from "../../services/utilService";
import { apiServiceConstants } from "../../constants";


import {
  ShiftTime,
  Group,
  TemplateAvailability,
} from "../../components/Shared/DoctorList/doctor-list.model";
import _ from "lodash";
import {
  CareTeamFullListResInterface,
  CareTeamFullListResModel, 
  UpdateCareTeamRequestParams,
  UpdateCareTeamResponseInterface,
  UpdateCareTeamResponseModel,
} from "../StatusBoard/StatusBoard.model";

const getPatientHistory = async (
  params: any,
  searchText: any,
  caseFilterType: any,
  isEMTUser: any
): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patient-history/?search=${searchText}&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }&reg_code=${utilService.getNetwork()}&guid=${utilService.getLoggedUserGuid()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&status_type=${caseFilterType}&is_ems=${isEMTUser}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const caseListResp = res as any;
      const result: any = {
        isSuccess: caseListResp.isSuccess,
        result: caseListResp.result,
        status: caseListResp.status,
        message: caseListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getUpdatedPatientHistory = async (params?: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patient-history/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.HEAD,
      utilService.getDeviceType()
    )
    .then((res) => {
      const caseListResp = res as any;
      const result: any = {
        isSuccess: caseListResp.isSuccess,
        result: caseListResp.result,
        status: caseListResp.status,
        message: caseListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getCaseHistory = async (params: any, searchText: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/patient-case-history/?search=${searchText}&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }&reg_code=${utilService.getNetwork()}&guid=${utilService.getLoggedUserGuid()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService.getCurrentMinutes().toString()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const caseListResp = res as any;
      const result: any = {
        isSuccess: caseListResp.isSuccess,
        result: caseListResp.result,
        status: caseListResp.status,
        message: caseListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getInPatientCaseHistory = async (
  params: any,
  searchText: any
): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/patient-case-history/?search=${searchText}&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }&reg_code=${utilService.getNetwork()}&guid=${utilService.getLoggedUserGuid()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&inpatient=true`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const caseListResp = res as any;
      const result: any = {
        isSuccess: caseListResp.isSuccess,
        result: caseListResp.result,
        status: caseListResp.status,
        message: caseListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getCaseHistoryDetailsList = async (params: any,isEMTUser:any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patient/${
        params.caseHistoryId
      }/?reg_code=${utilService.getNetwork()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&time_zone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }&guid=${utilService.getLoggedUserGuid()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const caseListResp = res as any;
      const result: any = {
        isSuccess: caseListResp.isSuccess,
        // result:isEMTUser?caseListResp.result?.[0]: setCaseListModel(caseListResp.result?.[0]),
        result: setCaseListModel(caseListResp.result?.[0]),
        fetchedResult:caseListResp.result?.[0],
        status: caseListResp.status,
        message: caseListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setCaseListModel = (payload: any): any => {

  let caseListArr = () =>{
  return {
    case_type_name: payload.case_type_name,
    created_by: payload.created_by,
    display_name: payload.display_name,
    dob: payload.dob,
    mrn: payload.mr_number,
    eta: payload.eta,
    gender: payload.gender,
    hospital: payload.hospital,
    id: payload.id,
    location: payload.location,
    media_file: payload.media_file,
    message: payload.message,
    name: payload.name,
    timer_end: payload.timer_end,
    timer_start: payload.timer_start,
    primary_md: mapPrimaryMdData(payload.primary_md),
    providers: mapProvidersData(payload.emergency_providers),
    site_guid: payload.site_guid,
    patient_guid: payload.patient_guid,
    emsNetworkCode: payload.ems_network_code,
    canTransfer: payload.can_transfer,
    isAccepted: payload.is_accepted,
    isRejected: payload.is_rejected,
    isTransferred: payload.is_transferred,
    canEdit: payload.can_edit,
    caseSubmitted: payload.case_submitted,
    age: payload.age,
    timerStopped: payload.timer_stopped,
    timerStart_time: payload.timer_start_time,
    timerDuration: payload.timer_duration,
    caseTypeId: payload.case_type_id,
    inpatient: payload.inpatient,
    // addedToEmergencyUser: payload.inpatient
    //   ? mapPrimaryMdData(payload.added_to_emergency_user)
    //   : [{}],
    addedToEmergencyUser:mapPrimaryMdData(payload.added_to_emergency_user),
    emtUserName: payload.emt_user_name,
    emtUserContactDetails: payload.emt_user_contact_details,
    bedNumber: payload.bed_number,
    unitName: payload.unit_name,
    statusBoardName: payload.status_board_name,
    isCancelled: payload.is_cancelled,
    isCompleted: payload.is_completed,
    patientCaseTypes: payload.patient_case_types,
    otherCaseTypeName: payload.other_case_type_name,
    cancelCompleteInfo: payload.cancel_complete_info,
    teamsAvailable: payload.teams_available,
  };
}
return caseListArr;
};

const mapProvidersData = (payload: any): any => {
  let DoctorListArray = payload?.map((object: any, key: any) => {
    return {
      guid: object.guid,
      firstName: object.first_name,
      lastName: object.last_name,
      displayName: object.display_name,
      profilePic: mapProfilePicData(object.profile_pic),
      color: object.color,
      shiftTime: mapShiftTimeDetails(object.shift_time),
      onGoing: object.on_going,
      groups: object.groups,
      mobileNumber: object.mobile_number,
      scheduleNames: object.schedule_names,
      red: object.red,
      leave: object.leave,
      speciality: object.speciality,
      yellow: object.yellow,
      templateAvailability: mapTemplateAvailabilityDetails(
        object.template_availability
      ),
      isSelected: false,
      isPermanentlySelected: object.isSelected,
      emergencyProviderId: object.emergency_provider_id,
      numberBadge: object.number_badge,
      providerAddedBy: object.provider_added_by,
      providerAlertStatus: object.provider_alert_status,
      providerSendOn: object.provider_send_on,
      providerResponseTime: object.provider_response_time,
      teamsAvailable: object.teams_available,
      profileStatusMessage: object.profile_status_message,
      statusMessageAvailable: object.status_message_available,
    };
  });
  return DoctorListArray;
};

const mapProvidersListData = (payload: any): any => {
  let DoctorListArray = payload?.map((object: any, key: any) => {
    return {
      guid: object.guid,
      firstName: object.first_name,
      lastName: object.last_name,
      displayName: object.display_name,
      profilePic: mapProfilePicData(object.profile_pic),
      color: object.color,
      shiftTime: mapShiftTimeDetails(object.shift_time),
      onGoing: object.on_going,
      groups: object.groups,
      mobileNumber: object.mobile_number,
      scheduleNames: object.schedule_names,
      red: object.red,
      leave: object.leave,
      speciality: object.speciality,
      yellow: object.yellow,
      templateAvailability: mapTemplateAvailabilityDetails(
        object.template_availability
      ),
      isSelected: false,
      isPermanentlySelected: object.isSelected,
      emergencyProviderId: object.emergency_provider_id,
      numberBadge: object.number_badge,
      providerAddedBy: object.provider_added_by,
      providerAlertStatus: object.provider_alert_status,
      providerSendOn: object.provider_send_on,
      providerResponseTime: object.provider_response_time,

      careTeamAlertStatus: object.care_team_user_alert_status,
      careTeamResponseTime: object.care_team_user_response_time,
      careTeamSendOn: object.care_team_user_send_on,
    };
  })
  return DoctorListArray;
};

const mapPrimaryMdData = (payload: any): any => {
  let DoctorListArray = payload?.map((object: any, key: any) => {
    return {
      guid: object.guid,
      firstName: object.first_name,
      lastName: object.last_name,
      displayName: object.display_name,
      profilePic: mapProfilePicData(object.profile_pic),
      color: object.color,
      shiftTime: mapShiftTimeDetails(object.shift_time),
      onGoing: object.on_going,
      groups: object.groups,
      mobileNumber: object.mobile_number,
      scheduleNames: object.schedule_names,
      red: object.red,
      leave: object.leave,
      speciality: object.speciality,
      yellow: object.yellow,
      templateAvailability: mapTemplateAvailabilityDetails(
        object.template_availability
      ),
      isSelected: false,
      isPermanentlySelected: object.isSelected,
      emergencyProviderId: object.emergency_provider_id,
      numberBadge: object.number_badge,
    };
  });
  return DoctorListArray;
};

const mapProfilePicData = (profilePic: string) => {
  if (!_.isEmpty(profilePic)) {
    if (
      !profilePic.includes("://thecallcentral.com") &&
      !profilePic.includes("assets/images/defaultProfilePic.png")
    ) {
      profilePic = utilService.getBaseUrl() + profilePic;
    }
  } else {
    profilePic = "assets/images/defaultProfilePic.png";
  }
  return profilePic;
};

const mapShiftTimeDetails = (shiftTimeData: Array<ShiftTime>) => {
  var shiftTimeObject: any;
  if (shiftTimeData == null) {
    return [];
  } else {
    let shiftTimeArray: Array<ShiftTime> = [];
    shiftTimeData.map((items: any) => {
      shiftTimeObject = {
        scheduleNameId: items.schedule_name_id,
        startTime: items.start_time,
        endTime: items.end_time,
        group: mapGroupDetails(items.group),
      };
      shiftTimeArray.push(shiftTimeObject);
    });
    return shiftTimeArray;
  }
};

const mapTemplateAvailabilityDetails = (
  templateAvailabilityData: TemplateAvailability
) => {
  if (templateAvailabilityData == null) {
    return {};
  } else {
    var templateAvailabilityObject = {
      id: templateAvailabilityData.id,
      active: templateAvailabilityData.active,
      startTime: templateAvailabilityData.start_time,
      endTime: templateAvailabilityData.end_time,
    };
    return templateAvailabilityObject;
  }
};

const mapGroupDetails = (groupData: Group) => {
  var groupObject = {
    id: groupData.id,
    name: groupData.name,
    speciality: groupData.speciality,
  };

  return groupObject;
};

const getTimer = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/timer-case-patient/?reg_code=${utilService.getNetwork()}&patient_guid=${
        params.patient_guid
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesCardResp = res as any;
      const result: any = {
        isSuccess: notesCardResp.isSuccess,
        displayNotesCard: notesCardResp,
        status: notesCardResp.status,
        message: notesCardResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const updateSiteDetails = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/resend-start-a-case/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesCardResp = res as any;
      const result: any = {
        isSuccess: notesCardResp.isSuccess,
        displayNotesCard: notesCardResp,
        status: notesCardResp.status,
        message: notesCardResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const updateTerminateCase = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/cancel-complete-case-patient/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesCardResp = res as any;
      const result: any = {
        isSuccess: notesCardResp.isSuccess,
        displayNotesCard: notesCardResp,
        status: notesCardResp.status,
        message: notesCardResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const updateCasePatient = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patient/${
        params.caseHistoryId
      }/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesCardResp = res as any;
      const result: any = {
        isSuccess: notesCardResp.isSuccess,
        displayNotesCard: notesCardResp,
        status: notesCardResp.status,
        message: notesCardResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getCareTeamList = async (
  params: any
): Promise<CareTeamFullListResInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patient-care-team/?reg_code=${utilService.getNetwork()}&patient_id=${
        params.patient_id
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const careTeamResp = res as CareTeamFullListResModel;
      const result: CareTeamFullListResInterface = {
        isSuccess: careTeamResp.isSuccess,
        status: careTeamResp.status,
        message: careTeamResp.message,
        groupList: careTeamResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: CareTeamFullListResInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getCareTeamMembers = async (
  params: any
): Promise<CareTeamFullListResInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/care-team-users-list/?reg_code=${utilService.getNetwork()}&care_team_id=${
        params.care_team_id
      }&patient_id=${params.patientId}&time_zone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const careTeamResp = res as CareTeamFullListResModel;
      const result: CareTeamFullListResInterface = {
        isSuccess: careTeamResp.isSuccess,
        status: careTeamResp.status,
        message: careTeamResp.message,
        groupList: mapProvidersListData(careTeamResp.result),
      };
      return result;
    })
    .catch((err) => {
      const result: CareTeamFullListResInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getAllCareTeam = async (
  params: any
): Promise<CareTeamFullListResInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patient-care-team-all/?reg_code=${utilService.getNetwork()}&site_id=${
        params.site_Id
      }&name=${params.name}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const careTeamResp = res as CareTeamFullListResModel;
      const result: CareTeamFullListResInterface = {
        isSuccess: careTeamResp.isSuccess,
        status: careTeamResp.status,
        message: careTeamResp.message,
        groupList: careTeamResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: CareTeamFullListResInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const updateCareTeam = async (
  params: UpdateCareTeamRequestParams
): Promise<UpdateCareTeamResponseInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patient-care-team/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as UpdateCareTeamResponseModel;
      const result: UpdateCareTeamResponseInterface = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
        groupList: response.result,
      };
      return result;
    })
    .catch((err) => {
      const result: UpdateCareTeamResponseInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getDeIdentificationDetails = async (params:any
): Promise<any> => {  
  const respApiResult = await apiService
    .apiCall(`deidentification/deidentify-data/?reg_code=${utilService.getNetwork()}`,params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
        groupList: response.result,
      };
      return result;
    })
    .catch((err) => {
      const result: UpdateCareTeamResponseInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

export const CaseHistoryService = {
  getCaseHistory,
  getCaseHistoryDetailsList,
  getTimer,
  updateCasePatient,
  updateSiteDetails,
  getInPatientCaseHistory,
  getPatientHistory,
  updateTerminateCase,
  getAllCareTeam,
  updateCareTeam,
  getCareTeamList,
  getCareTeamMembers,
  getUpdatedPatientHistory,
  getDeIdentificationDetails
};
